import colors from '@constants/colors';

import Text from '@components/Text';

import RequireDot from '..';

function RequireDotDesc() {
  return (
    <Text size={12} weight={500}>
      <RequireDot />
      필수 항목
    </Text>
  );
}

export default RequireDotDesc;
